import { DetailedHTMLProps, ImgHTMLAttributes, memo } from "react"

export const FlagFallback = memo<DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>>((props) => {
    return <img src="/styles/base/images/flags/unknown.png" alt={props.alt} title={props.title} />
})
